import {
  PricingPlan as RawPricingPlan,
  PricingPlans as RawPricingPlans,
  PricingStrategy,
  PricingTierPrice
} from '@atlassiansox/asc-product-catalog';
import { PricingPeriod } from '../models';

export type PricingTier = {
  readonly starter: boolean;
  readonly pricingStrategy: PricingStrategy;
  readonly unitDescription: string;
  readonly unitLimitLower: number;
  readonly unitLimitUpper: number | null;
  readonly prices: ReadonlyArray<PricingTierPrice>;
};

export type PricingPlan = ReadonlyArray<PricingTier>;

export type PricingPlans = {
  readonly [key in PricingPeriod]?: PricingPlan;
};

export function sanitizePricingPlans({
  monthly,
  annual
}: RawPricingPlans): PricingPlans {
  return {
    [PricingPeriod.MONTHLY]: sanitizePricingPlan(monthly),
    [PricingPeriod.ANNUAL]: sanitizePricingPlan(annual)
  };
}

const MIN_UNIT_LIMIT = 1;

// the first tier starts with a lower unit limit of 0, which for WAC needs to be 1
const correctFirstTierUnitLimitLower = (
  priceTiers: RawPricingPlan
): PricingPlan => {
  const { unitLimitLower } = priceTiers[0];

  const correctedUnitLimitLower = Math.max(
    unitLimitLower || MIN_UNIT_LIMIT,
    MIN_UNIT_LIMIT
  );

  return [
    {
      ...priceTiers[0],
      unitLimitLower: correctedUnitLimitLower
    } as PricingTier
  ].concat(priceTiers.slice(1) as PricingTier[]);
};

export function sanitizePricingPlan(
  pricingPlan?: RawPricingPlan
): PricingPlan | undefined {
  if (pricingPlan) {
    return correctFirstTierUnitLimitLower(pricingPlan);
  } else {
    return undefined;
  }
}

// import { PriceTier } from '@atlassian/bxp-price-calculation';

// const MAX_UNIT_LIMIT = 5000;

// // pricing tiers out of HAMS have data that is invalid
// // in various ways for displaying pricing on WAC

// // these functions each make a transformation that makes valid
// // the price tier data for our use case

// // it doesn't make sense to have a unit limit below one on any tier
// // for display on WAC, also the max tier limit shown should be 5000
// const clampUnitLimits = (priceTiers: PriceTier[]): PriceTier[] =>
//   priceTiers.map(priceTier => {
//     const { unitLimitLower, unitLimitUpper } = priceTier;

//     const [clampedUnitLimitLower, clampedUnitLimitUpper] = [
//       unitLimitLower,
//       unitLimitUpper
//     ].map(unitLimit =>
//       Math.max(Math.min(unitLimit, MAX_UNIT_LIMIT), MIN_UNIT_LIMIT)
//     );

//     priceTier.unitLimitLower = clampedUnitLimitLower;
//     priceTier.unitLimitUpper = clampedUnitLimitUpper;

//     return priceTier;
//   });

// // sometimes the first tier has a lower and upper unit limit of -987654321
// // so drop this tier entirely
// const dropInvalidFirstTier = (priceTiers: PriceTier[]): PriceTier[] => {
//   const { unitLimitLower, unitLimitUpper } = priceTiers[0];

//   return unitLimitLower === -987654321 &&
//     unitLimitLower === unitLimitUpper &&
//     priceTiers.length > 1
//     ? priceTiers.slice(1)
//     : priceTiers;
// };

// export default function(priceTiers: PriceTier[]): PriceTier[] {
//   return [
//     dropInvalidFirstTier,
//     clampUnitLimits,
//     correctFirstTierUnitLimitLower
//   ].reduce((tiers, tiersTransformFn) => tiersTransformFn(tiers), priceTiers);
// }
